import {
	getMeratusAccountCodeLabel,
	getMeratusAccountCodeOptions,
} from '@shared/utils/meratus';
import type { EditableColumn } from '@client/components/EditableTable';

type MeratusAccountCodeConfig = Record<string, {
	label: string;
	accountCode: string;
}>;

type MeratusAccountCodeRow = {
	accountCodeOverride?: string | null;
};

type GetMeratusAccountCodeColumnOptions<Row extends MeratusAccountCodeRow> = {
	editable?: boolean | ((row?: Row) => boolean);
};

const getMeratusAccountCodeColumn = <Row extends MeratusAccountCodeRow, KeyDataIndex extends keyof Row>(
	config: MeratusAccountCodeConfig,
	options: GetMeratusAccountCodeColumnOptions<Row> = {},
): EditableColumn<Row, KeyDataIndex> => ({
	dataIndex: 'accountCodeOverride',
	title: 'Account',
	editable: options.editable ?? (() => true),
	editingProps: {
		type: 'select' as const,
		required: true,
		inputProps: {},
		options: getMeratusAccountCodeOptions(config),
	},
	render: (_code: string | null, record: Row) => {
		const code = record.accountCodeOverride;

		if (code == null) {
			return '-';
		}

		const label = getMeratusAccountCodeLabel(code, config);

		return label != null ? `${label} (${code})` : code;
	},
});

export default getMeratusAccountCodeColumn;
